import {
  MESSAGE_GOT_NEW,
  MESSAGE_SET_RECEIVERS,
  MESSAGE_CLEAN,
  MESSAGE_SEE_CONVERSATION,
  MESSAGE_GET_LATEST_CONVERSATIONS_REQUEST,
  GET_CHAT_MESSAGES_REQUESTING,
  MESSAGE_OPEN_CONVERSATION_REQUESTING,
  MESSAGE_GET_CLIENT_NAME_REQUESTING,
  MESSAGE_SENDING,
  MESSAGE_LIKE_REQUESTING,
  REMOVE_MESSAGE_REQUESTING,
} from "./constants";
import { IMessageUser } from "./types";

// utilisé ?
export const gotNewMessage = message => ({ type: MESSAGE_GOT_NEW, message });

export const seeConversation = (payload: string) => {
  return {
    type: MESSAGE_SEE_CONVERSATION,
    payload,
  };
};

export const setReceivers = (payload: IMessageUser[]) => {
  return {
    type: MESSAGE_SET_RECEIVERS,
    payload,
  };
};

export const getLatestConversationsRequest = (payload: { userId: string }) => {
  return {
    type: MESSAGE_GET_LATEST_CONVERSATIONS_REQUEST,
    payload,
  };
};

export const cleanMessage = () => {
  return {
    type: MESSAGE_CLEAN,
  };
};

export const getChatMessagesRequest = (payload: {
  conversationId: string;
  page: number;
}) => {
  return {
    type: GET_CHAT_MESSAGES_REQUESTING,
    payload,
  };
};

// sender: {_id, picture, name}
// receiver => je ne sais pas ce que c'est
// dans la DB, le receiver contient aussi _id, picture, name
export const openConversationRequest = (payload: {
  receivers: IMessageUser[];
  conversationId?: string | "";
  name?: string | "";
}) => {
  return {
    type: MESSAGE_OPEN_CONVERSATION_REQUESTING,
    payload,
  };
};

export const getMessageClientNameRequest = (payload: { userId: string }) => {
  return {
    type: MESSAGE_GET_CLIENT_NAME_REQUESTING,
    payload,
  };
};

export const sendMessage = (payload: { message: string }) => {
  return {
    type: MESSAGE_SENDING,
    payload,
  };
};

export const likeMessage = (payload: { messageId: string; userId: string }) => {
  return {
    type: MESSAGE_LIKE_REQUESTING,
    payload,
  };
};

export const removeMessage = (payload: { messageId: string }) => {
  return {
    type: REMOVE_MESSAGE_REQUESTING,
    payload,
  };
};
